export default {
  productRow1: 'The cost, speed, and innovation benefits of digital transformation are clear, but legacy tools create barriers to digitalization. JWI products have been built from scratch, taking advantage of modern technology enablers, to meet the requirements of todays manufacturers.',
  productRow2: 'Whether you are just getting started or need to replace your current software, JWIs powerful, cloud native applications mean you can deploy them at a pace that makes sense for your business.',
  productRow3: 'DIGITAL ',
  productRow4: 'ENGINEERING',
  productRow5: 'FACTORY',
  productRow6: 'GO BACK'
}
